import {connect} from 'react-redux'
import SideMenuBuyer from './SideMenuBuyer'
// import {getViewSite, getWishList} from '../../redux/action/headerAction'


const mapStoreToProps = state => ({
  languageName: state.header.headers
})
const mapDispatchToProps = dispatch => ({
  // getWishList: (requestdata)=>dispatch(getWishList(requestdata)),
  // getViewSite: (sendData)=>dispatch(getViewSite(sendData))
  // applyFilters:(filter_string)=>dispatch(applyFilters(filter_string))
})

export default connect(mapStoreToProps,mapDispatchToProps)(SideMenuBuyer)